import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { Router } from '@angular/router';
import { CollectionReportData } from '../../../@core/interfaces/report/collectionReport';

@Component({
  selector: 'ngx-otpverification',
  templateUrl: './otpverification.component.html',
  styleUrls: ['./otpverification.component.scss']
})
export class OtpverificationComponent implements OnInit {

  otpForm: FormGroup;
  @Input() phoneNum: string;
  @Input() purpose: string;
  @Input() branchID:string;

  @Input() initiatedTenantId:string;
  @Input() initiatedBranchId:string;
  @Input() initiatedForTenantId:string;
  @Input() initiatedForBranchId:string;

  

  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  protected readonly unsubscribe$ = new Subject<void>();
  otpVerified: boolean = false;
  otpResponse:string=null;
  get apiUrl(): string {
    return environment.apiUrl;
  }
  loadSpinner:boolean=false;


  constructor(private apiService:CollectionReportData,private fb: FormBuilder) {
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1),Validators.required]),
      digit2: this.fb.control('',[Validators.required, Validators.maxLength(1), Validators.minLength(1)]),
      digit3: this.fb.control('',[Validators.required, Validators.maxLength(1), Validators.minLength(1)]),
      digit4: this.fb.control('',[Validators.required, Validators.maxLength(1), Validators.minLength(1)]),
      digit5: this.fb.control('',[Validators.required, Validators.maxLength(1), Validators.minLength(1)]),
      digit6: this.fb.control('',[Validators.required, Validators.maxLength(1), Validators.minLength(1)]),
    });
  
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  }
  get fval() { return this.otpForm.controls; }
  ngOnInit(): void {
    if(!!this.d1Element)
    this.d1Element.nativeElement.focus();
  }


  onVerify() {

    if(this.otpForm.valid){
      let otp = "";
      otp += this.otpForm.get('digit1').value;
      otp += this.otpForm.get('digit2').value;
      otp += this.otpForm.get('digit3').value;
      otp += this.otpForm.get('digit4').value;
      otp += this.otpForm.get('digit5').value;
      otp += this.otpForm.get('digit6').value;
      let payload;
      if(this.purpose=="resetpasswordbyadmin"){
        payload={
          "otpCode":otp,
          "userMobileNumber":this.phoneNum,
          "purpose":this.purpose,
          "initiatedTenantId":this.initiatedTenantId,
        }

      }
      this.loadSpinner=true;
     //BranchId not in use in this URL, Using as DUMMY to due API dependency !
      this.apiService.searchList("communication/" + this.initiatedTenantId + '/' + this.initiatedBranchId+'/verifyOTPByUser', payload).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        debugger
        if(data.code==200){
          this.loadSpinner=false;
          this.otpVerified=true;
          this.otpResponse=data.status;
          setTimeout(() => { 
            this.diaClose.emit({ otpStatus: "approved" });
          }, 2000);

        }else{
          this.otpVerified=false;
          this.otpResponse=data.status;  
          this.loadSpinner=false; 
        }
  
      }, (error) => {
      }, () => {
      });

    }
  }
  onCancel() {
    this.diaClose.emit(null);
  }


}
